import React, { Component } from "react";
import { Button, Form, message, Input, Icon, Select } from "antd";
import FetchData from '@ezviz/FetchData';
import { escapeUserName, languageList } from "../common/utils/index";
import LoadingButton from "../components/LoadingButton";
import { connect } from "react-redux";
import intl from "react-intl-universal";
import Cookies from "js-cookie";
import util from '../utils/utils';
import actionDcLog from "../common/utils/actionDcLog";
import { fillUserInfo } from "../redux/actions/user";
import { countryList, changeNameToCode } from "../common/utils/country";
import getQueryString from '../common/utils/getQueryString';
// import Header from '../components/header/Header';
import md5 from "js-md5";
import "./Login.less";

// 定制配置
const logo = util.bizConfig.logo || 'https://resource.eziot.com/group2/M00/00/59/CtwQFmBh0iuAWGNqAAAKzpFva8U841.png';
const onlyUseEmail = util.bizConfig.onlyUseEmail;
const ezvizAuthEnable = util.bizConfig.ezvizAuthEnable;


let areaValue = "";
const checkEmailOrPhone = (rule, value, callback) => {
  const emailReg = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
  const phoneReg = /^[0-9_-]+$/;
  const spaceReg = /\s+/;
  if (!value) {
    callback(intl.get("login.message.account.notNull"));
    return;
  }
  if (value && spaceReg.test(value)) {
    if (onlyUseEmail) {
      callback(intl.get("login.holder.email"));
    } else {
      callback(intl.get("login.message.account.notSpace"));
    }
    return;
  }
  if (value.indexOf("@") !== -1) {
    if (value && emailReg.test(value)) {
      callback();
      return;
    } else {
      callback(intl.get("login.message.account.emailErr"));
      return;
    }
  } else {
    if (onlyUseEmail) {
      callback(intl.get("login.holder.email"));
    } else {
      if (/[^\d_-]/.test(value)) {
        callback(intl.get("login.message.account.common"));
        return;
      } else if (value && phoneReg.test(value)) {
        callback();
        return;
      } else {
        callback(intl.get("login.message.account.common"));
      }
    }
  }
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      captchaImg: "",
      isNeedSmsCode: false,
      showAreaCode: false,
      countryList: [],
      isPassword: true
    };
    this.handleLogin = this.handleLogin.bind(this);
    this.handleAccountChange = this.handleAccountChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {

    this.getAreaList();

  }
  getAreaList = () => {
    let currentLocale = intl.determineLocale({
      urlLocaleKey: 'lang',
      localStorageLocaleKey: 'lang'
    });
    console.log(`currentLocale => ${currentLocale}`);
    // const language = navigator.language;

    const browserLanguage = (navigator.language || navigator.browserLanguage).replace("-", "_")
    const language = currentLocale ? currentLocale.replace("-", "_") : browserLanguage;
    const success = data => {
      if (data && data.meta.code == 200) {
        this.setState({
          countryList: data.areas
        }, this.accountBlur);
      }
    };
    const error = err => {
      // message.error('获取国家列表失败')
    };
    const fetchData = new FetchData('/v3/users/area/list', {
      method: 'GET',
      query: { language },
    });
    fetchData.then((res) => {
      success(res)
    }).catch(e => {
      error(e)
    })
  }
  setAreaCode = () => {

    const language = navigator.language;
    const { countryList } = this.state;
    let lanItem = languageList.find(item => Object.keys(item)[0].toLowerCase() === language.toLowerCase().replace('-', '_'));
    const { setFieldsValue } = this.props.form;
    console.log("lanItem", lanItem)
    if (!lanItem) { // 未找到
      lanItem = languageList.find(item => Object.keys(item)[0].toLowerCase().indexOf(language.toLowerCase().replace('-', '_')) !== -1);
      console.log("lanItem", lanItem)
    }
    const country = Object.values(lanItem)[0];//Object.values(lanItem)[0];
    const countryLan = Object.keys(lanItem)[0];
    const countryObj = countryList.find(item => countryLan.indexOf(item.code) !== -1);
    if (!countryObj) return;
    areaValue = countryObj.name + "&" + countryObj.telephoneCode + "&" + countryObj.code + "&" + countryObj.id;
    // areaValue = `${countryObj.}_${countryObj.chinese_name}_${countryObj.phone_code}`
    setFieldsValue({
      areaCode: areaValue
    });
  };
  handleClick() {
    const { userInfo } = this.props;
    console.log("appInfo", userInfo);
  }
  getcaptchaImg = userName => {
    const areaCode = this.props.form.getFieldValue("areaCode")
    const success = data => {
      console.log("data", data);
      if (data.data) {
        this.setState({
          captchaImg: data.data
        });
      } else {
        message.error(intl.get("login.message.veriCode.getErr"));
      }
    };
    const error = err => {
      message.error(intl.get("home.license.message.netErr"));
      console.log(err);
    };
    const fetchData = new FetchData('/captcha', {
      method: 'GET',
      query: { indexcode: escapeUserName(userName, changeNameToCode(areaCode)), t: Math.random() }
    });
    fetchData.then((res) => {
      success(res)
    }).catch(e => {
      error(e)
    })

  };
  handleLogin(e, callback) {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log(err);
        console.log("Received values of form: ", values);

        const { account, password, smsCode = "", areaCode } = values;
        const success = data => {
          callback();
          console.log(data);
          if (data.code == 200) {
            if (window.localStorage && areaCode) {
              window.localStorage.setItem("areaCode", areaCode)
              window.localStorage.setItem("countryId", areaCode.split("&")[3])
            }
            console.log("login success");
            this.setState({
              loading: false
            });
            const returnUrl = getQueryString('returnUrl');
            window.location.href = returnUrl || "/home/product";
          } else if (data.code == 1002) {
            message.error(intl.get("login.message.accountPwdError"));
          } else if (data.code == 1005) {
            // 需要验证码
            message.error(intl.get("login.message.veriCode.notNull"));
            this.setState({
              isNeedSmsCode: true
            });
            this.getcaptchaImg(account);
          } else if (data.code == 1003) {
            // 需要验证码
            this.setState({
              isNeedSmsCode: true
            });
            this.props.form.setFields({
              smsCode: {
                value: '',
                errors: [new Error(intl.get("login.message.veriCode.inputErr"))],
              },
            });
            this.getcaptchaImg(account);
          } else if (data.code == -1) {
            // 需要验证码
            message.error(intl.get("login.message.account.inputErr"));
          } else {
            this.setState({
              loading: false
            });

            message.error(data.msg || data.code);
          }
        };
        const error = err => {
          callback();
          console.log(err);
          message.error(intl.get("login.message.netErr"));
          this.setState({
            loading: false
          });
        };
        const fetchData = new FetchData('/user/login', {
          method: 'POST',
          body: {
            account: escapeUserName(account, changeNameToCode(areaCode)),
            password: md5(password),
            smsCode: smsCode.toUpperCase(),
            indexcode: escapeUserName(account, changeNameToCode(areaCode))
          }
        });
        fetchData.then((res) => {
          success(res)
        }).catch(e => {
          error(e)
        })
      } else {
        callback();
      }
    });
    actionDcLog.clickDcLog(e);
  }
  handleAccountChange(e) {
    const value = e.target.value.trim();
    this.setState({
      account: value
    });
  }
  handlePasswordChange(e) {
    const value = e.target.value.trim();
    this.setState({
      password: value
    });
  }
  handleSubmit = e => { };
  getVeriCodeAgain = e => {
    const { getFieldValue } = this.props.form;
    const account = getFieldValue("account");
    this.getcaptchaImg(account);
    actionDcLog.clickDcLog(e);
  };
  accountBlur = () => {
    const { getFieldValue } = this.props.form;
    const account = getFieldValue("account");
    // 定制项目只支持邮箱登录
    if (onlyUseEmail) {
      return;
    }
    let showAreaCode = false;
    if (account && !/\s+/.test(account)) {
      showAreaCode = !/[^\d_-]/.test(account)
    }

    this.setState(
      {
        showAreaCode
      },
      () => {
        if (showAreaCode) this.setAreaCode();
      }
    );
  };
  render() {
    const { currentLang } = util;
    const { captchaImg, showAreaCode, countryList } = this.state;
    const { getFieldDecorator } = this.props.form;
    const suffix = this.state.isPassword ? <img style={{ width: 20, cursor: 'pointer' }} onClick={() => this.setState({ isPassword: false })} src='https://resource.eziot.com/group2/M00/00/59/CtwQFmBinbmATHVSAAACQKinl7I967.png' /> : <img style={{ width: 20, cursor: 'pointer' }} src='https://resource.eziot.com/group2/M00/00/59/CtwQF2BinbuAZD9xAAAB9rverpI084.png' onClick={() => this.setState({ isPassword: true })} />;
    return (
      <div className={`login ${currentLang == "zh-CN" ? '' : "login_en"}`}>
        <div className="logo">
          <img src={logo} alt="" />
        </div>
        <div className="title">{intl.get('login.title')}</div>
        <Form className="login-form">
          {showAreaCode && (
            <Form.Item>
              {getFieldDecorator("areaCode", {})(
                <Select showSearch size="large">
                  {countryList.map((item, index) => (
                    <Select.Option value={item.name + "&" + item.telephoneCode + "&" + item.code + "&" + item.id} key={index}>
                      {item.name}+{item.telephoneCode}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          )}
          <Form.Item>
            {getFieldDecorator("account", {
              rules: [
                // { required: true, message: "用户名不能为空", whitespace: true },
                { max: 32, message: intl.get("login.rule.account") },
                { validator: checkEmailOrPhone }
              ]
            })(
              <Input
                prefix={<img style={{ width: 16, cursor: 'pointer' }} src='https://resource.eziot.com/group2/M00/00/59/CtwQF2Bj68-ALXjnAAABRb2jLQ0502.png' />}
                size="large"
                placeholder={onlyUseEmail ? intl.get('login.holder.email') : intl.get('login.holder.account')}
                style={{ width: "100%" }}
                allowClear
                onBlur={this.accountBlur}
                onChange={(e) => {
                  const { setFieldsValue } = this.props.form;
                  setFieldsValue({
                    account: e.target.value
                  })
                  this.accountBlur()
                }}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("password", {
              rules: [{ required: true, message: intl.get("login.rule.password"), whitespace: true }]
            })(
              <Input
                prefix={<img style={{ width: 16, cursor: 'pointer' }} src='https://resource.eziot.com/group2/M00/00/59/CtwQFmBj69CAUkzOAAABQBSqED0145.png' />}
                suffix={suffix}
                placeholder={intl.get("login.holder.password")}
                style={{ width: "100%" }}
                type={this.state.isPassword ? 'password' : 'text'}
                size="large"
                onPressEnter={() => this.loadingButton.enterLoading()}
              />
            )}
          </Form.Item>
          {this.state.isNeedSmsCode && (
            <div>
              <Form.Item className="fl">
                {getFieldDecorator("smsCode", {
                  rules: [{ required: true, message: intl.get("login.message.veriCode.notNull"), whitespace: true }]
                })(<Input placeholder={intl.get("login.holder.veriCode")} style={{ width: 180 }} size="large" />)}
              </Form.Item>

              <div className="fr vericode-box">
                <div style={{ display: "inline-block" }} dangerouslySetInnerHTML={{ __html: this.state.captchaImg }} />
                <a href="javascript:;" onClick={this.getVeriCodeAgain} data-click-dclog="12" style={{marginLeft: '10px'}}>
                  {intl.get("login.btn.getImgCode")}
                </a>
              </div>
              <div className="clear" />
            </div>
          )}
          <div className="btn-box">
            <LoadingButton
              type="primary"
              className="login-form-button"
              onClick={this.handleLogin}
              size="large"
              ref={ref => (this.loadingButton = ref)}
              dataClickDclog="13"
            >
              {intl.get("login.btn.title")}
            </LoadingButton>
            <a className="login-form-forgot" href="/authrization/resetPassword/account" onClick={e => actionDcLog.pageDcLog(e)}>
              {intl.get("login.btn.forgetPwd")}
            </a>
          </div>
          {/* <div className="dashLine" /> */}
          <div className="noAccount">
            <span className="fl">
              {intl.get("login.content.noAccount")}&nbsp;
              <a href="/authrization/register/register" onClick={e => actionDcLog.pageDcLog(e)}>
                {intl.get("login.btn.register")}
              </a>
            </span>
            {ezvizAuthEnable
              &&
              <span className="fr">
                <a href={`/authrization/thirdPathLogin${window.location.search}`} onClick={e => actionDcLog.pageDcLog(e)}>
                  萤石云账号登录
                </a>
              </span>
            }
          </div>
        </Form>
      </div>
    );
  }
}
const mapStatetoProps = state => {
  console.log("mapStatetoProps-state-userInfo", state);
  // 需要的state数据
  return {
    //state : staet.文件名.变量
    userInfo: state.user.userInfo
  };
};

const mapDispatchToProps = dispatch => ({
  fillUserInfo: data => {
    console.log("fillUserInfo-Data", data);
    return dispatch(fillUserInfo(data));
  }
});
const LoginForm = Form.create()(Login);
export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(LoginForm);
